import * as React from 'react';
import NumberFormat from 'react-number-format';

interface IPriceText {
  price?: number | string | null;
  emptyValueText?: string;
}

const PriceText: React.FC<IPriceText> = (props) => {
  return props.price === null || props.price === undefined ? (
    <span>{props.emptyValueText ? props.emptyValueText : 'None'}</span>
  ) : (
    <NumberFormat
      value={props.price}
      decimalScale={2}
      fixedDecimalScale={true}
      prefix={'$ '}
      thousandSeparator={','}
      displayType={'text'}
    />
  );
};

export default PriceText;
